import React from "react";
import { Formik } from "formik";
import {
    withStyles,
    Button,
    Typography,
    CircularProgress
} from "@material-ui/core";
import * as Yup from "yup";
import { DropzoneArea } from 'material-ui-dropzone';
import { capitalize } from "../../sc-utilities";

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    }
});

const DeviceDependentSettingUploadForm = props => {
    const { classes, formSettings, loading, handleSubmit, translations, handleUpload, edit } = props;
    return (
        <div className={classes.root}>
            <Typography>
                {translations['supported_format'] || 'Supported format'}{' JSON and .XLSX '}.<br />
            </Typography>
            <Formik
                initialValues={{}}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(false);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { isValid, handleSubmit, dirty, isSubmitting } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <div>
                                <DropzoneArea
                                    filesLimit={1}
                                    maxFileSize={5368709120}
                                    getFileRemovedMessage={(fileName) => {
                                        const text = translations ? (
                                            capitalize(`${translations['file'] || 'File'} ${fileName} ${translations['removed'] || 'removed'}.`)
                                        ) : `File ${fileName} removed.`

                                        return text;
                                    }}
                                    getFileAddedMessage={(fileName) => {
                                        const text = translations ? (
                                            capitalize(`${translations['file'] || 'File'} ${fileName} ${translations['successfully_added'] || 'successfully added'}.`)
                                        ) : `File ${fileName} successfully added.`

                                        return text;
                                    }}
                                    getFileLimitExceedMessage={(filesLimit) => {
                                        const text = translations ? (
                                            capitalize(`${translations['maximum_allowed_number'] || 'Maximum allowed number of files exceeded. Only'} ${filesLimit} ${translations['allowed'] || 'allowed'}.`)
                                        ) : `Maximum allowed number of files exceeded. Only ${filesLimit} allowed`

                                        return text;
                                    }}
                                    getDropRejectMessage={(rejectedFile) => {
                                        const text = translations ? (
                                            capitalize(`${translations['File'] || 'File'} ${translations['was_rejected'] || 'was rejected'}.`)
                                        ) : `File was rejected.`

                                        return text;
                                    }}
                                    dropzoneText={`${translations['drag_and_drop_an'] || 'Drag and drop an'} .json ${translations['or'] || 'or'} .xlsx ${translations['file_here'] || 'file here or click'}`}
                                    onChange={handleUpload}
                                    acceptedFiles={['.xlsx', '.xls', '.json']}
                                />
                            </div>
                            <div>
                                {
                                    formSettings.ButtonSubmit ? (
                                        <Button
                                            className={classes.submit}
                                            variant="contained"
                                            type="submit"
                                            onClick={handleSubmit}
                                            disabled={!(isValid && dirty) || isSubmitting ? loading : !edit ? loading : false}
                                        >
                                            {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                        </Button>
                                    ) : null
                                }
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(DeviceDependentSettingUploadForm);